import { RouteConfig } from "vue-router";

const introductionPage = () => import("@/views/pages/customers/intro.vue");
const customerLayout = () => import("@/views/layouts/customer/qMaster.vue");
const customerStepLayout = () => import("@/views/layouts/customer/step/qMaster.vue");
const contractConfirmPage = () => import("@/views/pages/customers/contractConfirm.vue");
const customerHomePage = () => import("@/views/pages/customers/home.vue");
const repairHistory = () => import("@/views/pages/customers/repairHistory.vue");
const moveOut = () => import("@/views/pages/customers/moveOut.vue");
const moveOutThankYou = () => import("@/views/pages/customers/moveOutThankYou.vue");
const contractInformation = () => import("@/views/pages/customers/contractInformation.vue");
const receiptConfirmation = () => import("@/views/pages/customers/receiptConfirmation.vue");
const contractMovingCheckList = () => import("@/views/pages/customers/contractMovingCheckList.vue");
import { USER_TYPE } from "@/model/user";

const customerRouter: Array<RouteConfig> = [
  {
    path: "/customer",
    name: "customer",
    component: customerLayout,
    meta: {
      allowRole: [USER_TYPE.CUSTOMER],
    },
    children: [
      {
        path: "home",
        name: "customer.home",
        component: customerHomePage,
        meta: {
          pageTitle: "J-SYS",
          title: "Home",
          subTitle: "",
          className: "Home",
          root: true,
          permission: ['view', 'Home'],
        },
      },
      {
        path: "repair-property-history",
        name: "customer.repair-property-history",
        component: repairHistory,
        meta: {
          pageTitle: "修繕履歴 | J-SYSTEM",
          title: "修繕履歴",
          subTitle: "修繕履歴",
          className: "Repair Content History",
          permission: ['view', 'RepairContentHistory'],
        },
      },
      {
        path: "message",
        name: "customer.message",
        component: () => import("@/views/pages/customers/message.vue"),
        meta: {
          pageTitle: "トーク | J-SYSTEM",
          title: "トーク",
          subTitle: "トーク",
          className: "Talk with manager",
          permission: ['view', 'Message'],
        },
      },
      {
        path: "contract-information",
        name: "customer.contract-information",
        component: contractInformation,
        meta: {
          pageTitle: "契約情報 | J-SYSTEM",
          title: "契約情報",
          subTitle: "契約情報",
          className: "Contract Information",
          permission: ['view-info', 'Contract'],
        },
      },
      {
        path: "receipt-confirmation",
        name: "customer.receipt-confirmation",
        component: receiptConfirmation,
        meta: {
          pageTitle: "受領確認 | J-SYSTEM",
          title: "受領確認",
          subTitle: "受領確認",
          className: "Receipt Confirmation",
          permission: ['confirm', 'Receipt'],
        },
      },
      {
        path: "moving-checklist",
        name: "customer.moving-checklist",
        component: contractMovingCheckList,
        meta: {
          pageTitle: "入居時チェックリスト | J-SYSTEM",
          title: "入居時チェックリスト",
          subTitle: "入居時チェックリスト",
          className: "Contract Moving CheckList",
          permission: ['moving-checklist', 'Contract'],
        },
      },
    ],
  },
  {
    path: "/step",
    name: "step",
    component: customerLayout,
    children: [
      {
        path: "intro",
        name: "step.intro",
        component: introductionPage,
        meta: {
          pageTitle: "はじめに | J-SYSTEM",
          title: "はじめに",
          subTitle: "",
          className: "Admin",
          root: true,
          permission: ['view', 'introduction'],
        },
      },
    ]
  },
  {
    path: "/step",
    name: "step",
    component: customerStepLayout,
    children: [
      {
        path: "confirm-follow",
        name: "step.confirm-follow",
        component: contractConfirmPage,
        meta: {
          pageTitle: "受領確認 | J-SYSTEM",
          title: "受領確認",
          subTitle: "",
          className: "Admin",
          permission: ['confirm-follow', 'Contract'],
        },
      }
    ]
  },
  {
    path: "/customer",
    name: "customer",
    component: customerStepLayout,
    meta: {
      allowRole: [USER_TYPE.CUSTOMER],
    },
    children: [
      {
        path: "move-out",
        name: "customer.move-out",
        component: moveOut,
        meta: {
          pageTitle: "退去申請 | J-SYSTEM",
          title: "退去申請",
          subTitle: "退去申請",
          className: "Move Out",
          permission: ['move-out', 'Contract'],
        },
      },
      {
        path: "move-out-thank-you",
        name: "customer.move-out-thank-you",
        component: moveOutThankYou,
        meta: {
          pageTitle: "退去申請完了 | J-SYSTEM",
          title: "退去申請完了",
          subTitle: "退去申請完了",
          className: "Contract Move Out Thank You",
        },
      },
    ]
  },
];

export default customerRouter;
